<template>
  <div id="place-services-page">
    <vx-card>
      <vs-row>
        <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
          <span>{{ $t('places.alias') }}: </span>
          <span class="font-semibold"> {{ this.place.alias }}</span>
        </div>
        <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
          <span>{{ $t('places.subject') }}: </span>
          <span class="font-semibold"> {{ $t(`places.subjects.${this.place.subject}`) }}</span>
        </div>
        <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
          <span>{{ $t('places.category') }}: </span>
          <span class="font-semibold"> {{ $t(`places.categories.${this.place.category}`) }}</span>
        </div>
        <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
          <span>{{ $t('entity.state') }}: </span>
          <span class="font-semibold"> {{ $t(`entity.states.${this.place.state}`) }}</span>
        </div>
        <span class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
          <span>{{ $t('places.status') }}: </span>
          <span class="font-semibold"> {{ $t(`places.statuses.${this.place.status}`) }}</span>
        </span>
      </vs-row>
    </vx-card>
    <vue-persian-calender
      :events-list="events"
      date-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
      @on-day-click="openAddService"
      @on-event-click="openEditService"
    ></vue-persian-calender>
    <!-- ADD Service -->
    <vs-prompt
      class="calendar-event-dialog"
      :title="$t('personnel.add_shift')"
      :accept-text="$t('forms.add')"
      :cancel-text="$t('forms.cancel')"
      @accept="addService"
      :is-valid="validForm"
      :active.sync="activePromptAddService"
    >
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('employees.employee') }}</label>
        <v-select
          v-model="selectedEmployees"
          :clearable="false"
          :options="employeeOptions"
          name="selectedEmployees"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          multiple
        />
      </div>

      <div class="w-full mt-4" v-if="hasSpecialty">
        <label class="vs-input--label">{{ $t('personnel.specialty') }}</label>
        <v-select
          v-model="specialty"
          :clearable="false"
          :options="specialtyOptions"
          name="specialty"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>

      <!--Start Shift -->
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('personnel.shift_start') }}</label>

        <date-picker type="datetime" v-model="startDate" element="startDate" :min="$moment().format()" />
        <vs-input
          name="startDate"
          id="startDate"
          :value="
            $moment(startDate)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm dddd, DD MMMM YYYY')
          "
          v-validate="'required'"
          class="w-full"
        />
      </div>
      <!--End Shift -->
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('personnel.shift_end') }}</label>

        <date-picker
          type="datetime"
          v-model="endDate"
          element="endDate"
          :disabled="!startDate"
          :min="startDate"
          :max="
            $moment(startDate)
              .add(1, 'months')
              .format()
          "
        />
        <vs-input
          name="endDate"
          id="endDate"
          :value="
            $moment(endDate)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm dddd, DD MMMM YYYY')
          "
          class="w-full"
        />
      </div>
    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-prompt
      class="calendar-event-dialog"
      :title="$t('personnel.edit_shift')"
      :accept-text="$t('forms.edit')"
      :cancel-text="$t('forms.remove')"
      button-cancel="border"
      @cancel="removeService"
      @accept="editService"
      :is-valid="validForm"
      :active.sync="activePromptEditService"
    >
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('employees.employee') }}</label>
        <v-select
          v-model="employee"
          :clearable="false"
          :options="employeeOptions"
          name="employee"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>

      <div class="w-full mt-4" v-if="hasSpecialty">
        <label class="vs-input--label">{{ $t('personnel.specialty') }}</label>
        <v-select
          v-model="specialty"
          :clearable="false"
          :options="specialtyOptions"
          name="specialty"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>

      <!--Start Shift -->
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('personnel.shift_start') }}</label>

        <date-picker type="datetime" v-model="startDate" element="startDate2" :min="$moment().format()" />
        <vs-input
          name="startDate"
          id="startDate2"
          :value="
            $moment(startDate)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm dddd, DD MMMM YYYY')
          "
          v-validate="'required'"
          class="w-full"
        />
      </div>
      <!--Expiration Date -->
      <div class="w-full mt-4">
        <label class="vs-input--label">{{ $t('personnel.shift_end') }}</label>

        <date-picker
          type="datetime"
          v-model="endDate"
          element="endDate2"
          :disabled="!startDate"
          :min="startDate"
          :max="
            $moment(startDate)
              .add(1, 'months')
              .format()
          "
        />
        <vs-input
          name="endDate"
          id="endDate2"
          :value="
            $moment(endDate)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm dddd, DD MMMM YYYY')
          "
          class="w-full"
        />
      </div>
    </vs-prompt>

    <!-- SHOW EVENT -->
    <vs-popup
      class="calendar-event-dialog"
      :title="$t('personnel.shift')"
      :active.sync="activePromptSiftDetail"
    >
      <div class="w-full">
        <p>{{ $t('employees.employee') }}: {{ showEvent.title }}</p>
      </div>

      <div class="w-full mt-4" v-if="hasSpecialty">
        <p>{{ $t('personnel.specialty') }}: {{ $t(`health_services.${showEvent.specialty}`) }}</p>
      </div>
      <!-- Start Shift -->
      <div class="w-full mt-4">
        <p>{{ $t('personnel.shift_start') }}: {{ showEvent.startDateTime | datetime }}</p>
      </div>
      <!-- End Shift -->
      <div class="w-full mt-4">
        <p>{{ $t('personnel.shift_end') }}: {{ showEvent.endDateTime | datetime }}</p>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePersianCalender from 'vue-persian-calendar'

import moduleBusiness from '@/store/business/moduleBusiness'
import modulePlaces from '@/store/places/modulePlaces'
import moduleServices from '@/store/services/moduleServices'

export default {
  name: 'PlaceServices',
  components: {
    VuePersianCalender
  },
  data() {
    return {
      place: null,
      events: [],
      employees: [],
      selectedEmployees: [],
      activePromptAddService: false,
      activePromptEditService: false,
      activePromptSiftDetail: false,
      showEvent: {},
      disabledFrom: true,
      startDate: this.$moment().format(),
      endDate: this.$moment().format(),
      employee: null,
      specialist: [],
      specialty: { value: undefined },
      serviceId: null
    }
  },
  computed: {
    validForm() {
      return (
        (this.employee || this.selectedEmployees.length) &&
        this.startDate &&
        this.endDate &&
        (this.hasSpecialty ? this.specialty : true)
      )
    },
    employeeOptions() {
      const employees = []
      this.employees.forEach(e => {
        if (e.status === 'active')
          employees.push({ label: `${e.user.details.firstName} ${e.user.details.lastName}`, value: e.id })
      })
      return employees
    },
    specialtyOptions() {
      return Object.keys(this.specialist).map(s => ({
        label: this.$t(`health_services.${this.place.subject}.${s}`),
        value: `${this.place.subject}.${s}`
      }))
    },
    hasSpecialty() {
      return ['doctor_specialist', 'specialist_doctor'].includes(this.place.subject)
    }
  },
  methods: {
    updatePlace() {
      this.$store.dispatch('place/fetchPlace', this.$route.params.placeId).then(res => {
        this.place = res.data.place

        if (this.hasSpecialty)
          this.specialist = this.$store.getters['config/provinceServiceDetails'][this.place.subject]

        this.updateEmployees()
      })
    },
    updateEmployees() {
      this.$store.dispatch('business/fetchBusiness', this.place.businessId).then(res => {
        this.employees = res.data.business.employees
        this.setServices()
      })
    },
    setServices() {
      this.events = []
      this.place.services.forEach(s => {
        const user = this.employees.find(e => e.id === s.employeeId)?.user
        if (user)
          this.events.push({
            id: s.id,
            title: `${user.details.firstName} ${user.details.lastName}`,
            specialty: s.specialty,
            startDateTime: this.$moment(s.startDate),
            endDateTime: this.$moment(s.endDate)
          })
      })
      this.$vs.loading.close()
    },
    openAddService(day) {
      if (day.isBefore(this.$moment(), 'day')) {
        this.$notifyWarning(this.$t('personnel.not_valid_day_to_add_shift'))
        return
      }
      this.disabledFrom = true
      this.startDate = day.locale('en').format()
      this.endDate = day.locale('en').format()
      this.activePromptAddService = true
    },
    openEditService(event) {
      if (event.endDateTime.isBefore(this.$moment(), 'day')) {
        this.activePromptSiftDetail = event
        this.showEvent = event
        return
      }
      const service = this.place.services.find(s => s.id === event.id)
      const user = this.employees.find(e => e.id === service.employeeId).user
      this.serviceId = service.id

      this.employee = {
        label: `${user.details.firstName} ${user.details.lastName}`,
        value: service.employeeId
      }
      this.specialty = {
        label: this.$t(`health_services.${service.specialty}`),
        value: service.specialty
      }
      this.startDate = event.startDateTime
        .clone()
        .locale('en')
        .format()
      this.endDate = event.endDateTime
        .clone()
        .locale('en')
        .format()
      this.activePromptEditService = true
    },
    async addService() {
      for (let i = 0; i < this.selectedEmployees.length; i++) {
        const employee = this.selectedEmployees[i]
        const service = {
          placeId: this.place.id,
          state: 'active',
          status: 'idle',
          employeeId: employee.value,
          specialty: this.specialty.value,
          startDate: this.startDate,
          endDate: this.endDate
        }

        try {
          const res = await this.$store.dispatch('service/createService', service)
          if (res) {
            const user = this.employees.find(e => e.id === employee.value).user
            service.added = 1
            this.$store.commit('place/ADD_PLACE_SERVICE', {
              id: res.data.id,
              state: 'active',
              status: 'idle',
              placeId: this.place.id,
              employeeId: employee.value,
              specialty: this.specialty.value,
              startDate: this.$moment(this.startDate)
                .locale('en')
                .format(),
              endDate: this.$moment(this.endDate)
                .locale('en')
                .format()
            })

            this.events.push({
              id: res.data.id,
              title: `${user.details.firstName} ${user.details.lastName}`,
              specialty: this.specialty.value,
              startDateTime: this.$moment(this.startDate),
              endDateTime: this.$moment(this.endDate)
            })
            // this.$vs.notify({
            //   title: this.$t('forms.successfully_added'),
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'success'
            // })
          }
        } catch (e) {
          service.added = -1
        }
      }
    },
    editService() {
      const service = {
        employeeId: this.employee.value,
        specialty: this.specialty.value,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$store.dispatch('service/editService', { id: this.serviceId, data: service }).then(() => {
        const user = this.employees.find(e => e.id === this.employee.value).user

        this.$store.commit('place/UPDATE_PLACE_SERVICE', {
          id: this.serviceId,
          state: 'active',
          status: 'idle',
          placeId: this.place.id,
          employeeId: this.employee.value,
          specialty: this.specialty.value,
          startDate: this.$moment(this.startDate)
            .locale('en')
            .format(),
          endDate: this.$moment(this.endDate)
            .locale('en')
            .format()
        })

        this.events = this.events.filter(e => e.id !== this.serviceId)
        this.events.push({
          id: this.serviceId,
          title: `${user.details.firstName} ${user.details.lastName}`,
          specialty: this.specialty.value,
          startDateTime: this.$moment(this.startDate),
          endDateTime: this.$moment(this.endDate)
        })

        this.$vs.notify({
          title: this.$t('forms.successfully_edited'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
    },
    removeService() {
      this.$store.dispatch('service/removeService', this.serviceId).then(() => {
        this.events = this.events.filter(e => e.id !== this.serviceId)

        this.$store.commit('place/DELETE_PLACE_SERVICE', this.serviceId)

        this.$vs.notify({
          title: this.$t('forms.successfully_deleted'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePlaces.isRegistered) {
      this.$store.registerModule('place', modulePlaces)
      modulePlaces.isRegistered = true
    }
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
    if (!moduleServices.isRegistered) {
      this.$store.registerModule('service', moduleServices)
      moduleServices.isRegistered = true
    }
    this.updatePlace()
  }
}
</script>

<style lang="scss">
#place-services-page {
  .vpc_day:not(.vpc_past),
  .vpc_event {
    cursor: pointer !important;
  }
}
</style>
